import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button, Stack } from "@chakra-ui/react";

import { useLayout } from "contexts/LayoutContext/LayoutContext";

const AirBundlePayoutActions = ({
  form,
  uploadInProgress,
  dataDetailsCollected,
  setDataDetailsCollected,
  onSubmit,
  isAirLuggage,
  submitError,
  isDisabled,
}: {
  form: UseFormReturn;
  uploadInProgress?: boolean;
  dataDetailsCollected?: boolean;
  setDataDetailsCollected?: (value: boolean) => void;
  onSubmit: (data) => void;
  isAirLuggage?: boolean;
  submitError: boolean;
  isDisabled?: boolean;
}) => {
  const { t } = useTranslation();
  const { setValue, watch, formState, handleSubmit } = form;
  const { activeStep, setActiveStep } = useLayout();

  const handleRemoveCountry = () => {
    setValue("country", "");
  };

  const { isSubmitting } = formState;

  const isLoadingPayoutButton = isSubmitting || uploadInProgress;
  const isDisabledPayoutButton = isLoadingPayoutButton || submitError || isDisabled;

  const countryCode = watch("country")?.value || "";
  const showUpload = !isAirLuggage;
  const showBankStep = countryCode && (!showUpload || document);

  const handleNextStep = () => {
    if (setDataDetailsCollected) {
      setActiveStep(activeStep + 1);
      setDataDetailsCollected(false);
    }
    return null;
  };

  const handleBackStep = () => {
    if (setDataDetailsCollected) {
      setActiveStep(activeStep - 1);
      setDataDetailsCollected(true);
    }
    return null;
  };

  return (
    <Stack width="100%" direction={{ base: "column-reverse", md: "row" }} justifyContent="right" mt={6} spacing={5}>
      {showBankStep && (
        <Button
          variant="secondary"
          size="s"
          onClick={handleRemoveCountry}
          isDisabled={isDisabledPayoutButton}
          data-testid="back-button"
        >
          {t("common.back")}
        </Button>
      )}

      {setDataDetailsCollected && !showBankStep && !dataDetailsCollected && (
        <Button variant="secondary" size="s" onClick={handleBackStep} data-testid="back-button">
          {t("common.back")}
        </Button>
      )}
      <Button
        isLoading={isLoadingPayoutButton}
        isDisabled={isDisabledPayoutButton}
        onClick={dataDetailsCollected ? handleSubmit(handleNextStep) : handleSubmit(onSubmit)}
        size="s"
        data-testid={dataDetailsCollected ? "save-data-details-button" : "request-payment-button"}
      >
        {showBankStep ? t("instant_cash.payout.request_payment") : t("common.continue")}
      </Button>
    </Stack>
  );
};

export default AirBundlePayoutActions;
